import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import App from './App.vue';

import store from './store/store';
import router from './router/router';
// fetch proxy
import { Http } from './http/http';
import './filters/filters';

// mixins
import documentTitle from './utils/mixins/title';

// plugins
import { bootstrap, bootstrapIcons } from './plugins/bootstrap';
import vuelidate from './plugins/vuelidate';
import { i18n } from './plugins/vuei18n';
import moment from './plugins/moment';
import getUserName from './plugins/getUserName';
import cyrillicToTranslit from './plugins/cyrillicToTranslit';

// assets
import 'normalize.css';
import './assets/styles/index';
import './utils/libraryIcons';

// sentry integration
try {
  if (typeof process.env.VUE_APP_SENTRY_DSN !== 'undefined') {
    Sentry.init({
      dsn: `${process.env.VUE_APP_SENTRY_DSN}`,
      environment: typeof process.env.VUE_APP_MODE !== 'undefined'
        ? process.env.VUE_APP_MODE : 'production',
      integrations: [new VueIntegration({ Vue, attachProps: true })],
    });
  }
} catch (e) {
  // eslint-disable-next-line no-console
  console.log('Error, sentry is not enabled: ', e.message);
}

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.mixin(documentTitle);
Vue.use(getUserName);
Vue.use(cyrillicToTranslit);

Vue.config.productionTip = false;

const token = localStorage.getItem('user-token');
if (token) {
  Http.HEADERS.Authorization = token;
}

new Vue({
  store,
  router,
  bootstrap,
  bootstrapIcons,
  moment,
  vuelidate,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
